<template>
  <div id="student">
    <NavigationBar />
    <HeroSectionStudent />
    <GrowthPathFlow />
    <AbilityCertification />
    <BadgeAndRankSystem />
    <RealTaskTypes />
    <TrustSection />
    <StudentCTA />
    <FooterSection />
  </div>
</template>

<script>
import NavigationBar from '@/components/Navigation.vue'
import HeroSectionStudent from '@/components/HeroSectionStudent.vue'
import GrowthPathFlow from '@/components/GrowthPathFlow.vue'
import AbilityCertification from '@/components/AbilityCertification.vue'
import BadgeAndRankSystem from '@/components/BadgeAndRankSystem.vue'
import RealTaskTypes from '@/components/RealTaskTypes.vue'
import TrustSection from '@/components/TrustSection.vue'
import StudentCTA from '@/components/StudentCTA.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'StudentPage',
  components: {
    NavigationBar,
    HeroSectionStudent,
    GrowthPathFlow,
    AbilityCertification,
    BadgeAndRankSystem,
    RealTaskTypes,
    TrustSection,
    StudentCTA,
    FooterSection
  }
}
</script>

<style scoped>
#student {
  width: 100%;
}
</style>
